import React, { lazy, Suspense } from 'react';
import { CompatRoute as Route } from 'react-router-dom-v5-compat';
import { PageLoader } from 'common-components/loading/PageLoader';

const RegisterView = lazy(() => import('views/non-auth/RegisterView'));
const ResetPasswordView = lazy(() => import('../views/non-auth/ResetPasswordView'));

interface NonAuthRoutesProps {
  isAuthenticated: boolean;
}

// Non Authorized Routes
const NonAuthRoutes = (props: NonAuthRoutesProps): JSX.Element => (
  <Suspense fallback={<PageLoader />}>
    <Route path="/register" component={RegisterView} />
    <Route path="/reset" component={ResetPasswordView} />
  </Suspense>
);

export default NonAuthRoutes;
